import React from 'react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './page-shell.css'

const LegalTerms = () => {
  return (
    <div className="page-shell">
      <Helmet>
        <title>MDMC Terms</title>
        <meta property="og:title" content="MDMC Terms" />
      </Helmet>
      <Navigation></Navigation>
      <main>
        <section className="page-hero">
          <h1 className="page-hero-title">Terms of Service</h1>
          <p className="page-hero-subtitle">
            Public usage rules for the SFW generator, research library, forms,
            and client-facing MDMC surfaces.
          </p>
        </section>
        <div className="page-panel">
          <h3>Acceptable Use</h3>
          <p>
            MDMC.dev is for public-safe meme creation, research, client staging
            discovery, and access requests. Do not submit illegal content, private
            credentials, harassment, adult content, malware, or material you do
            not have permission to use.
          </p>
        </div>
        <div className="page-panel">
          <h3>Generated Content</h3>
          <p>
            Meme output is user-directed and may depend on third-party rendering
            services. You are responsible for reviewing output before sharing it
            and for respecting trademarks, copyrights, platform rules, and basic
            human decency.
          </p>
        </div>
        <div className="page-panel">
          <h3>Client And Operator Access</h3>
          <p>
            Access requests do not create an account automatically. MDMC may
            approve, deny, limit, or revoke access to staging surfaces and
            operator workflows to protect client work and public infrastructure.
          </p>
          <div className="page-cta">
            <a className="btn btn-primary" href="https://tx.wtf" target="_blank" rel="noopener noreferrer">Join tx.wtf</a>
            <a className="btn btn-secondary" href="/legal/privacy">Read Privacy Policy</a>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  )
}

export default LegalTerms

